module.exports = __webpack_public_path__ + "static/media/signzy.41163d57.svg";